export class DeviceLicence {
  public isTrial: boolean;
  public hasIssue: boolean;
  public serial: string;
  public expireDays: number;
  /**
   * Date in the format YYYY-MM-DD
   */
  public expireDate: string;
  public blockedSerial: string;
  public suggestedSerial: string;

  constructor(deviceLicenceResponse: DeviceLicenceResponse) {
    this.isTrial = deviceLicenceResponse.isTrial;
    this.hasIssue = deviceLicenceResponse.hasIssue;
    this.serial = deviceLicenceResponse.serial;
    this.expireDays = deviceLicenceResponse.expireDays;
    this.expireDate = deviceLicenceResponse.expireDate;
    this.blockedSerial = deviceLicenceResponse.blockedSerial;
    this.suggestedSerial = deviceLicenceResponse.suggestedSerial;
  }

  /**
   * Checks whether the licence is valid at the current time
   *
   * @returns True if the licence is valid
   */
  public isExpired() {
    if (this.expireDays > 0) {
      return false;
    } else {
      return true;
    }
  }
}

export interface DeviceLicenceResponse {
  isTrial: boolean;
  hasIssue: boolean;
  serial: string;
  expireDays: number;
  /**
   * Date in the format YYYY-MM-DD
   */
  expireDate: string;
  blockedSerial: string;
  suggestedSerial: string;
}
